<template>
  <layout-main-inner title="设置">
    <layout-card-wrap>
      <el-row
        :gutter="20"
        type="flex">
        <!-- <el-col :md="6">
          <bom-card :config="alert"></bom-card>
        </el-col> -->
        <el-col
          v-if="hasPermission[450]"
          :md="6">
          <cate-card :config="cate"></cate-card>
        </el-col>
        <el-col
          v-if="hasPermission[455]"
          :md="6">
          <label-card :config="label"></label-card>
        </el-col>
        <el-col
          v-if="hasPermission[460]"
          :md="6">
          <staff-card :config="staff"></staff-card>
        </el-col>
        <el-col
          v-if="hasPermission[465]"
          :md="6">
          <warehouse-card :config="warehouse"></warehouse-card>
        </el-col>
        <el-col
          v-if="hasPermission[471]"
          :md="6">
          <customer-card :config="customer"></customer-card>
        </el-col>
        <el-col
          v-if="hasPermission[472]"
          :md="6">
          <template-card :config="templates"></template-card>
        </el-col>
        <el-col
          v-if="hasPermission[473]"
          :md="6">
          <log-card :config="logs"></log-card>
        </el-col>
        <el-col
          v-if="hasPermission[477]"
          :md="6">
          <fail-log-card :config="failLogs"></fail-log-card>
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>

// import BomCard from './busi/bom-card'
import { mapState } from 'vuex'
import CateCard from './busi/cate-card'
import LabelCard from './busi/label-card.vue'
// import SeriesCard from './busi/series-card.vue'
import StaffCard from './busi/staff-card.vue'
import WarehouseCard from './busi/warehouse-card.vue'
import TemplateCard from './busi/template-card.vue'
import CustomerCard from './busi/customer-card.vue'
import LogCard from './busi/log-card.vue'
import FailLogCard from './busi/fail-log-card.vue'

const bom = require('./busi/bom.png')
const shp = require('./busi/shp.png')
const bq = require('./busi/bq.png')
const ry = require('./busi/ry.png')
const ck = require('./busi/ck.png')
const xl = require('./busi/xl.png')
const kd = require('./busi/kd.png')
const cus = require('./busi/cus.png')
const rz = require('./busi/rizhi.png')
function getPermission(list) {
  const map = {}
  const array = [450, 455, 460, 465, 470, 471, 472, 473, 477]
  array.forEach(i => {
    map[i] = list.findIndex(s => s.funcId === i) > -1
  })
  return map
}
export default {
  name: 'NewSettings',
  components: { FailLogCard, LogCard, CateCard, LabelCard, StaffCard, WarehouseCard, TemplateCard, CustomerCard },
  props: {},
  data() {
    return {
      alert: {
        title: 'DOM表',
        info: '用于维护商品的DOM表信息',
        image: bom
      },
      cate: {
        title: '商品品种',
        info: '用于维护商品的品种信息',
        image: shp
      },
      label: {
        title: '标签管理',
        info: '用于产品码和箱码的生产和下载',
        image: bq
      },
      staff: {
        title: '人员管理',
        info: '用于维护企业人员信息和功能权限',
        image: ry
      },
      warehouse: {
        title: '仓库信息',
        info: '用于维护从企业ERP同步的仓库信息',
        image: ck
      },
      customer: {
        title: '客户信息',
        info: '用于查看从企业ERP同步的客户信息',
        image: cus
      },
      series: {
        title: '产品系列',
        info: '用于维护企业的系列信息并关联仓库',
        image: xl
      },
      templates: {
        title: '快递模板',
        info: '用于维护企业的快递模板信息',
        image: kd
      },
      logs: {
        title: '日志查看',
        info: '用于查看企业员工的操作日志',
        image: rz
      },
      failLogs: {
        title: '推送日志',
        info: '查询推送失败的销售订单列表',
        image: rz
      }
    }
  },
  computed: {
    ...mapState({
      module: state => state.account.module
    }),
    hasPermission() {
      const settings = this.module.find(s => s.menuId === 400) || {}
      const operations = settings.children[0].operations || []
      return getPermission(operations)
    }
  }
}
</script>
